'use client';

import { useTranslation } from 'react-i18next';

import { Button } from '@/components/buttons';
import { ImageComponent } from '@/components/Image';
import { Modals } from '@/helpers/modals';
import { useModalsStore } from '@/store';

export const GameErrorNotFound = () => {
  const { t } = useTranslation('common');
  const open = useModalsStore.use.open();

  return (
    <>
      <ImageComponent
        alt="rolled eyes emoji"
        height={80}
        src="/emojis/rolledEyes.webp"
        width={80}
      />
      <p>{t('nonAuthGameError')}</p>
      <div className="button-wrap">
        <Button onClick={() => open(Modals.Login)} secondary>
          {t('button.login')}
        </Button>
        <Button onClick={() => open(Modals.Registration)} primary>
          {t('button.register')}
        </Button>
      </div>
    </>
  );
};
